import constants from "../../constants";

export default [
	{
		logo: "/images/footer/facebook.svg",
		linkAddress: constants.socialLinks.facebook,
		linkTitle: "Link to Submittable's Facebook",
	},
	{
		logo: "/images/footer/twitter.svg",
		linkAddress: constants.socialLinks.twitter,
		linkTitle: "Link to Submittable's Twitter",
	},
	{
		logo: "/images/footer/instagram.svg",
		linkAddress: constants.socialLinks.instagram,
		linkTitle: "Link to Submittable's Instagram",
	},
	{
		logo: "/images/footer/youtube.svg",
		linkAddress: constants.socialLinks.youtube,
		linkTitle: "Link to Submittable's YouTube channel",
	},
	{
		logo: "/images/footer/linkedin.svg",
		linkAddress: constants.socialLinks.linkedIn,
		linkTitle: "Link to Submittable's LinkedIn",
	},
];

export const podcastLinks = [
	{
		logo: "/images/footer/spotifyPodcasts.svg",
		linkAddress: "https://open.spotify.com/show/0VqgWXAGMZ4s5Rc7g5LNuc",
		linkTitle: "Link to Submittable's Spotify Podcast",
	},
	{
		logo: "/images/footer/googlePodcasts.svg",
		linkAddress: "https://podcasts.google.com/feed/aHR0cHM6Ly9mYXN0Lndpc3RpYS5uZXQvY2hhbm5lbHMvNGZjdTRmeHU0aC9yc3M/episode/ZjAwYWVhMDItZDA5Yi00MjcyLWFjZjQtZjI2NDhhZGE2MDZl?sa=X&ved=0CAUQkfYCahcKEwigmJm06aX2AhUAAAAAHQAAAAAQAQ",
		linkTitle: "Link to Submittable's Google Podcast",
	},
	{
		logo: "/images/footer/applePodcasts.svg",
		linkAddress: "https://podcasts.apple.com/us/podcast/impact-audio/id1576770635",
		linkTitle: "Link to Submittable's Apple Podcast",
	},
]
